{
  "ping": "Ping response time",
  "date": {
    "seconds": "s.",
    "minutes": "min.",
    "hours": "h.",
    "days": "d.",
    "weeks": "w.",
    "months": "mon.",
    "years": "y."
  }
}